import { AnimatePresence, motion } from 'framer-motion';

import { PropsWithChildren } from 'react';

interface IFormFillInputsSectionProps extends PropsWithChildren {
	displaySection?: boolean;
}

function FormFillInputsSection({ children, displaySection }: IFormFillInputsSectionProps) {
	return (
		<AnimatePresence
			// SSR would otherwise paint `initial` (height 0), collapsing the form until hydration
			initial={false}
			mode="wait"
			onExitComplete={() => null}
		>
			{!!displaySection && (
				<motion.div
					layout
					initial={{ height: 0, opacity: 0 }}
					animate={{ height: 'auto', opacity: 1 }}
					exit={{ height: 0, opacity: 0 }}
					transition={{
						duration: 0,
						ease: 'linear',
					}}
				>
					{children}
				</motion.div>
			)}
		</AnimatePresence>
	);
}

export default FormFillInputsSection;
